"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var preOrderNowExternal_1 = require("../../graphql/queries/preOrderNowExternal");
var useErrorHandler_1 = require("../../../common/hooks/useErrorHandler");
exports.usePreOrderOnlineExternal = function (dealId, postCode) {
    var _a = client_1.useLazyQuery(preOrderNowExternal_1.default.PRE_ORDER_ONLINE_EXTERNAL, {
        variables: {
            dealId: dealId,
            postCode: postCode,
        },
        fetchPolicy: 'cache-first',
    }), fetchPreOrderOnlineExternal = _a[0], _b = _a[1], data = _b.data, loading = _b.loading, error = _b.error;
    useErrorHandler_1.default(error);
    return { fetchPreOrderOnlineExternal: fetchPreOrderOnlineExternal, data: data, loading: loading, error: error };
};
